
























































import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { Gender } from '@/util/gender'
import { PluginMixin } from '@spa/mixins/plugin'

@Component
export default class GenderForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: null })
  gender: Gender | null

  @Prop({ default: false })
  isRequired: boolean

  @Prop({ default: false })
  disabled: boolean

  @Prop({ required: true })
  handleGenderChanged: (val: Gender | null) => void

  Gender = Gender

  get hasExtendedValidationError(): boolean {
    return !!this.$slots.extendedValidationErrorMessage
  }

  get validation(): any {
    return {
      required: this.isRequired,
    }
  }

  handleInputGender(gender: Gender | null): void {
    this.handleGenderChanged(gender)
  }
}
